<template>
  <div class="admin-image-edit">
    <toolbar 
      :loading=loading 
      :info=info 
      :primary_action=save_image 
      :primary_action_text="'Upload'"
      :secondary_action="new_upload ? null : delete_image"
      :secondary_action_text="'Delete'">
    </toolbar>
    <div class="wrap">
      <div class="image-edit">
        <content-section :content="image_content"></content-section>
        <div class="upload">
          <div class="card">
            <input type='file'
              @change="files_selected($event.target.name, $event.target.files)"
              accept="image/*"/>
          </div>
        </div>
        <div class="controls" v-if="image">
          <div class="top">
           <div class="title">{{image.key}}</div>
          </div>
            {{image.url}}
          <div class="inputs">
            <div class="col">
              <div v-if="new_upload" class="input"><div class="label">Key</div><input type="text" v-model="image.key"></div>
              <div class="input"><div class="label">Title</div><input type="text" v-model="image.meta.title"></div>
              <div class="input"><div class="label">Source</div><input type="text" v-model="image.meta.source"></div>
              <div class="input"><div class="label">Location</div><input type="text" v-model="image.meta.location"></div>
            </div>
            <!-- <div class="col">
              <div class="input"><div class="label">Tags</div><input type="text"></div>
              <div class="input"><div class="label">Links</div><input type="text"></div>
              <div class="input"><div class="label">Image</div><input type="text"></div>
              <div class="input"><div class="label">Published?</div><input type="checkbox"></div>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ContentSection from '../common/Content'
import Toolbar from './Toolbar'
export default {
  components: {
    ContentSection,
    Toolbar
  },
  data: () => {
    return {
      image: null,
      image_file: null,
      new_upload: false,
      loading: true,
      info: null
    }
  },
  computed: {
    image_content() {
      return Object.assign({ type: 'Image' }, this.image)
    },
  },
  created: function() {
    this.fetch_image()
  },
  methods: {
    fetch_image: function() {
      this.$store.dispatch('fetchImage', this.$route.params.key).then((data) => {
        this.loading = false
        if(data.image) {
          this.image = data.image
        } else {
          console.log('could not find image')
          if(this.$route.params.key == "upload") {
            this.new_upload = true
            this.image = {key: "new-image", meta: {}}  
          }
        }
      }, () => {
        // error
        this.$router.push({ path: '/admin/images' })
      })
    },
    save_image: function() {
      if(this.image_file == null && this.new_upload) {
        this.info = "Missing image file"
        return;
      }
      this.info = ""
      this.loading = true
      let img_file = this.image_file ? this.image_file.split(',')[1] : null
      let payload = Object.assign({image_file: img_file}, this.image)
      delete payload.url
      delete payload.url_small
      this.$store.dispatch('updateImage', payload).then((res) => {
        console.log('updated!')
        this.loading = false
        this.new_upload = false
        this.$router.push({ path: '/admin/images/' + this.image.key })
        this.$router.go()
        //this.fetch_image()
      }, (err) => {
        console.error(err)
        this.loading = false
      })
    },
    delete_image: function() {
      this.loading = true
      this.$store.dispatch('deleteImage', this.image.key).then((res) => {
        console.log('deleted')
        console.log(res)
        this.$router.push({ path: '/admin/images' })
        this.loading = false
      }, (err) => {
        console.error(err)
        this.info = err
        this.loading = false
      })
    },
    files_selected: function(name, files) {
      this.loading = true
      new Promise((resolve, reject) => {
        let reader = new FileReader()
        reader.readAsDataURL(files[0])
        reader.onload = function () {
          resolve(reader.result)
        }
      }).then((uploaded_image_file) => {
        this.image_file = uploaded_image_file
        this.image = this.image || {key: this.$route.params.key, meta: {}}
        console.log(this.image)
        this.loading = false
      })
    }
  }
}
</script>
